<ng-container *ngIf="!isBuses; else searchBuses">
  <app-search-bar-flights-mobile
    [source]="source"
    [destination]="destination"
    [isExchangeSearch]="isExchangeSearch"
    [exchangeTripType]="exchangeTripType"
    [departureDateIsDisabled]="departureDateIsDisabled"
    [routeChangeIsDisabled]="!!routeChangeIsDisabled"
    [isResultsPage]="isResultsPage"
    [searchType]="searchType"
    [currentUrl]="currentUrl"
    [searchData]="searchData"
    [departurePlace]="departurePlace$ | async"
    [arrivalPlace]="arrivalPlace$ | async"
    [departureDate]="departureDate$ | async"
    [arrivalDate]="arrivalDate$ | async"
    [flightType]="flightType$ | async"
    [activeFlightClass]="flightClass$ | async"
    [passengerArrangement]="passengerArrangement$ | async"
    [autoCompletePlaces]="autoCompletePlaces$ | async | autocompleteVm"
    [airports]="airports"
    [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces$ | async"
    [baggageIncluded]="baggageIncluded"
    [validate]="validate"
    [flightOffers]="flightOffers$ | async"
    (swapLocationsEmitter)="swapLocationsEmitter.emit()"
    (emitArrangement)="emitArrangement.emit($event)"
    (emitFlightClassSelection)="emitFlightClassSelection.emit($event)"
    (selectFlightType)="selectFlightType.emit($event)"
    (selectPlace)="selectPlace.emit($event)"
    (emitSearch)="emitSearch.emit()"
    (toggleSearchByFlexDates)="toggleSearchByFlexDates.emit($event)"
    (showMobileCalendarEvent)="showMobileCalendarEvent.emit($event)"
    (placeInputChanged)="placeInputChanged.emit($event)"
    (selectFlightCalendar)="selectCalendar.emit($event)"
    (selectedBaggageIncluded)="selectedBaggageIncluded.emit($event)"
    (removeAutoCompletePlaces)="clearAutocompletePlaces()"
    (amplitudeEvent)="amplitudeEvent.emit($event)"
    (toggleEvent)="toggleEvent.emit()">
  </app-search-bar-flights-mobile>
</ng-container>

<ng-template #searchBuses>
  <app-search-bar-buses-mobile
    [isResultsPage]="isResultsPage"
    [searchType]="searchType"
    [departurePlace]="departureTerminal$ | async"
    [arrivalPlace]="arrivalTerminal$ | async"
    [departureDate]="departureDate$ | async"
    [arrivalDate]="arrivalDate$ | async"
    [flightType]="busType$ | async"
    [passengerArrangement]="passengerArrangement$ | async"
    [autoCompletePlaces]="autoCompletePlaces$ | async"
    [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces$ | async"
    (swapLocationsEmitter)="swapLocationsEmitter.emit()"
    (emitArrangement)="emitArrangement.emit($event)"
    (selectBusType)="selectBusType.emit($event)"
    (selectPlace)="selectPlace.emit($event)"
    (emitSearch)="emitSearch.emit()"
    (showMobileCalendarEvent)="showMobileCalendarEvent.emit($event)"
    (placeInputChanged)="placeInputChanged.emit($event)"
    (selectFlightCalendar)="selectCalendar.emit($event)"
    (removeAutoCompletePlaces)="clearAutocompletePlaces()"
    (amplitudeEvent)="amplitudeEvent.emit($event)">
  </app-search-bar-buses-mobile>
</ng-template>
